var _style, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDiscord(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "discord_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 245 245",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".discord_svg__st0{fill:#7289da}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "discord_svg__st0",
    d: "M205.5,245h-166C17.7,245,0,227.3,0,205.5v-166C0,17.7,17.7,0,39.5,0h166C227.3,0,245,17.7,245,39.5v166 C245,227.3,227.3,245,205.5,245z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M164.1,185.4c0,0-5.4-6.4-9.9-12.1c19.6-5.5,27.1-17.8,27.1-17.8c-6.1,4-12,6.9-17.2,8.8 c-7.5,3.1-14.7,5.2-21.7,6.4c-14.4,2.7-27.5,1.9-38.8-0.1c-8.5-1.6-15.9-4-22-6.4c-3.4-1.3-7.2-3-10.9-5.1c-0.4-0.3-0.9-0.4-1.3-0.7 c-0.3-0.1-0.4-0.3-0.6-0.4c-2.7-1.5-4.2-2.5-4.2-2.5s7.2,12,26.2,17.7c-4.5,5.7-10,12.4-10,12.4c-33.1-1-45.7-22.8-45.7-22.8 c0-48.2,21.6-87.3,21.6-87.3c21.6-16.2,42.1-15.7,42.1-15.7l1.5,1.8C73.2,69.2,60.8,81,60.8,81s3.3-1.8,8.8-4.3c16-7,28.7-9,34-9.4 c0.9-0.1,1.6-0.3,2.5-0.3c9.1-1.2,19.5-1.5,30.2-0.3c14.2,1.6,29.5,5.8,45.1,14.4c0,0-11.8-11.2-37.3-19l2.1-2.4 c0,0,20.5-0.4,42.1,15.7c0,0,21.6,39.1,21.6,87.3C209.9,162.6,197.2,184.3,164.1,185.4z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "discord_svg__st0",
    d: "M98.6,124.8c-7.5,0-13.4,6.5-13.4,14.5c0,8,6,14.5,13.4,14.5c7.5,0,13.4-6.5,13.4-14.5 C112.1,131.4,106.1,124.8,98.6,124.8z M146.4,124.8c-7.5,0-13.4,6.5-13.4,14.5c0,8,6,14.5,13.4,14.5c7.5,0,13.4-6.5,13.4-14.5 C159.8,131.4,153.9,124.8,146.4,124.8z"
  })));
}

export default SvgDiscord;